module.exports = __webpack_public_path__ + "img/saveBg.b4b23cca.png";